import { Component, HostListener } from '@angular/core'
import { AppService } from './app.service'
import { Subscription } from 'rxjs'

import { environment } from "../../environments/environment"
import { StorageService } from '../shared/storage.service';
import { AuthService } from '../shared/security/auth.service';
import { LoginService } from '../pages/login/login.service';
import { Router } from '@angular/router';
import { Session } from './app.model';
export let isDebugMode = environment.isDebugMode


@Component({
  selector: 'flow-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  private subscriptions: Subscription[] = []
  session: Session = new Session()
  themeid: number = 1
  seconds: number = 0
  template: string =
    `
    <div class="spinner">
      <div></div>
      <div class="logo-spinner">
         <img class="logo-spinner-img" src="assets/img/logo-app.png" />
      </div>
      <br/>
    </div>
  `
  constructor(
    private appService: AppService,
    private loginService: LoginService,
    private router: Router,
    private auth: AuthService,
    private storageService: StorageService
  ) {
    isDebugMode ? console.log(`constructor()`) : undefined
    //console.log(this.appService.session)
    this.session = this.appService.session
    this.utcTime()
  }

  @HostListener("document:keyup", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    isDebugMode ? console.log(`handleKeyboardEvent()`) : undefined
    this.seconds = 0;
  }

  @HostListener("mouseup", ["$event"])
  onMouseup(event: MouseEvent) {
    isDebugMode ? console.log(`onMouseup()`) : undefined
    this.seconds = 0;
    this.appService.eventClick.emit(event)
  }

  ngOnInit() {
    isDebugMode ? console.log(`ngOnInit()`) : undefined
    this.subscriptions.push(

      // this.auth.passportChange.subscribe(
      //   passport => {
      //     console.log(passport)
      //     // if (passport.passportid) {
      //     //   this.session.passportid = passport.passportid
      //     //   this.storageService.setObject("session", this.session)
      //     // }
      //   }
      // ),

      this.appService.eventSession.subscribe(
        session => {
          //console.log(session)
          this.session = session
          this.themeid = session.themeid
          this.storageService.setObject("session", session)
        }
      )

    )
  }

  ngOnDestroy() {
    isDebugMode ? console.log(`ngOnDestroy()`) : undefined
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }

  utcTime(): void {
    isDebugMode ? console.log(`utcTime()`) : undefined

    let timer = setInterval(() => {
      this.seconds += 1;
      //console.log(this.seconds)
      if (this.seconds > environment.timeout) {
        if (this.auth.loggedIn) {
          console.log('Efetuado logout por inatividade do usuário')
          clearInterval(timer)
          this.logout()
        }
      }
    }, 1000);


  }

  logout() {
    isDebugMode ? console.log(`logout()`) : undefined
    this.loginService.handleLogout();
    this.router.navigate(["/login"]);
  }

}
